<div>
    <button *ngIf="useTextButton" class="_button-primary _w-full" [matMenuTriggerFor]="menu" (click)="refresh()">
        <i class="fa-light fa-plus _mr-1"></i>Add to {{ 'proposal' | businessName }}
    </button>
    <button *ngIf="!useTextButton" [matMenuTriggerFor]="menu" (click)="refresh()" class="_bg-grayscale-white _text-grayscale-black _text-md _pill-circle _w-7 _h-7">
        <i class="fa-sharp fa-light fa-plus-minus"></i>
    </button>
    <mat-menu #menu="matMenu" class="mat-menu-up">
        <ng-container *ngFor="let wishlist of wishlists">
            <div mat-menu-item
                 class="wishlist-item"
                 (click)="containsListing(wishlist) ? removeFromWishlist($event, wishlist) : addToWishlist($event, wishlist.wishlistId)">
                <span class="_mr-4">{{ wishlist.name }}</span>
                <i *ngIf="containsListing(wishlist)" class="fa-light fa-check"></i>
                <i *ngIf="!containsListing(wishlist)" class="fa-light fa-plus"></i>
            </div>
        </ng-container>
        <mat-divider></mat-divider>
        <button mat-menu-item
                class="wishlist-item"
                (click)="openCreateShortlistDialog($event)">
            Create new {{ 'wishlist' | businessName }}
        </button>
        <button mat-menu-item
            class="wishlist-item"
            [routerLink]="['/wishlists']">
            View {{ 'wishlist' | businessName }}s
        </button>
    </mat-menu>
</div>
